<template>
  <div :id="this.$route.name">
    <card back>
      <template v-slot:header>
        <h4 class="d-inline">دیسکت مالیات</h4>
        <hr />
      </template>

      <template v-slot:content>
        <tab v-if="!noData" :tab="Tablist">
          <template v-slot:content0>
            <div class="row">
              <div class="col-12 text-left">
                <span dir="ltr">
                  {{ WP }}
                </span>
              </div>
            </div>
          </template>

          <template v-slot:content1>
            <div class="row">
              <div class="col-12 text-left">
                <span dir="ltr">
                  {{ WK }}
                </span>
              </div>
            </div>
          </template>

          <template v-slot:content2>
            <div class="row">
              <div class="col-12 text-left">
                <span dir="ltr">
                  {{ WH }}
                </span>
              </div>
            </div>
          </template>
        </tab>
        <div v-else>
          <div class="row">
            <div class="col-md-6 col-12">
              <card>

                <template v-slot:header>
                  <h6 class="d-inline">وضعیت اطلاعات حقوق بگیران</h6>
                  <hr />
                </template>

                <template v-slot:content>
                  <small id="LblGetWorkShopCombo"> کارگاه </small>
                  <SearchableCombo :edit="false" :code="null" :grp="0" @ResultCombo="GetWorkShopCombo"
                    :defaultvalue="DataAxois.TblWorkshopId" :rownumintable="3"
                    :action="'TblSalaryCombo/GetWorkShopCombo'" :method="'POST'" :idinput="'GetWorkShopCombo'"
                    :keyItem="'GetWorkShopCombo'" :ClassProps="'required'">
                  </SearchableCombo>
                  <hr />
                  <span> همه پرسنل </span>
                  <hr />
                  <div v-for="(item, index) in listpersonel" :key="index" class="my-1 ListHover py-3 px-2">
                    <div class="d-inline">{{ index + 1 }} - {{ item.NamFam }}</div>
                    <span class="d-inline float-left">
                      <div class="btn-group btn-group-toggle w-100" data-toggle="buttons" tabindex="-1" dir="ltr">
                        <label tabindex="-1" class="btn btn-dark hover-warning"
                          :class="item.TaxDisketPersonelState == 3 ? 'active focus' : ''">
                          <input tabindex="-1" @click="item.TaxDisketPersonelState = 3" type="radio" name="options"
                            id="rdiTarkibi" />
                          عدم ارسال
                        </label>
                        <label tabindex="-1" class="btn btn-dark hover-info"
                          :class="item.TaxDisketPersonelState == 2 ? 'active focus' : ''">
                          <input tabindex="-1" @click="item.TaxDisketPersonelState = 2" type="radio" name="options"
                            id="rdiBanki" />
                          ویرایش
                        </label>
                        <label tabindex="-1" class="btn btn-dark hover-success"
                          :class="item.TaxDisketPersonelState == 1 ? 'active focus' : ''">
                          <input tabindex="-1" @click="item.TaxDisketPersonelState = 1" type="radio" name="options"
                            id="rdiNaghdi" />
                          جدید
                        </label>
                      </div>
                    </span>
                  </div>
                </template>
              </card>
            </div>

            <div class="col-md-6 col-12">
              <card>

                <template v-slot:header>
                  <h6 class="d-inline">اطلاعات فایل خلاصه فهرست حقوق</h6>
                  <hr />
                </template>

                <template v-slot:content>
                  <form autocomplete="off">
                    <small id="LblBedehiMaliatiMaheJari"> بدهی مالیاتی ماه جاری </small>
                    <input type="text" class="form-control InputText required" v-model="DataAxois.BedehiMaliatiMaheJari"
                      dir="ltr" />
                    <small id="LblBedehiMaliatiMaheGozashte"> بدهی مالیاتی ماه گذشته </small>
                    <input type="text" class="form-control InputText" v-model="DataAxois.BedehiMaliatiMaheGozashte"
                      dir="ltr" />
                    <small id="LblTarixSabetRoozaname"> تاریخ ثبت در دفتر روزنامه </small>
                    <date-picker color="dimgray" input-class="required form-control required"
                      v-model="DataAxois.TarixSabetRoozaname" clearable :editable="true"
                      placeholder="تاریخ"></date-picker>
                    <small id="LblGetComboById"> نحوه پرداخت </small>
                    <SearchableCombo :edit="false" :code="null" :grp="28" @ResultCombo="GetNahvePardakhetGrp28"
                      :defaultvalue="DataAxois.NahvePardakhetId" :rownumintable="3"
                      :action="'TblSalaryCombo/GetComboById'" :method="'POST'" :idinput="'GetNahvePardakhetGrp28'"
                      :keyItem="'GetNahvePardakhetGrp28'" :ClassProps="'required'">
                    </SearchableCombo>
                    <small id="LblSerialCheck"> شماره سریال چک </small>
                    <input type="text" class="form-control InputText" v-model="DataAxois.SerialCheck" dir="ltr" />
                    <small id="LblTarixCheck"> تاریخ چک </small>
                    <date-picker color="dimgray" input-class=" form-control " v-model="DataAxois.TarixCheck" clearable
                      :editable="true" placeholder="تاریخ چک"></date-picker>
                    <small id="LblBankGrp29"> نام بانک </small>
                    <SearchableCombo :edit="false" :code="null" :grp="29" @ResultCombo="GetBankGrp29"
                      :defaultvalue="DataAxois.CodeBank" :rownumintable="3" :action="'TblSalaryCombo/GetComboById'"
                      :method="'POST'" :idinput="'BankGrp29'" :keyItem="'BankGrp29'" :ClassProps="'required'">
                    </SearchableCombo>
                    <small id="LblNameShobe"> نام شعبه </small>
                    <input type="text" class="form-control InputText" v-model="DataAxois.NameShobe" />
                    <small id="LblShomareHesab"> شماره حساب </small>
                    <input type="text" class="form-control InputText" v-model="DataAxois.ShomareHesab" dir="ltr" />
                    <small id="LblMablaghPardakhti"> مبلغ پرداختی </small>
                    <input type="text" class="form-control InputText required" v-model="DataAxois.MablaghPardakhti"
                      dir="ltr" />
                    <small id="LblMablaghPardakhti"> مبلغ پرداختی خزانه </small>
                    <input type="text" class="form-control InputText required"
                      v-model="DataAxois.MablaghPardakhtiKhazane" dir="ltr" />
                  </form>
                  <hr />
                  <div class="row">
                    <div class="col-md-5 col-12">
                      <button class="btn btn-success w-100" v-if="!isEdit" @click.prevent="SaveDeta()">ثبت
                        اطلاعات</button>
                      <button class="btn btn-success w-100" v-if="isEdit" @click.prevent="EditDeta()">ویرایش
                        اطلاعات</button>
                    </div>
                    <div class="col-md-4 col-12">
                      <button class="btn btn-warning w-100" @click.prevent="cancelEdit()">انصراف</button>
                    </div>
                  </div>
                </template>
              </card>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5 col-12 mt-5">
            <button v-if="!noData" class="btn btn-success w-100" @click.prevent="getEditDeta()">ویرایش اطلاعات</button>
          </div>
          <div class="col-md-3 col-12 mt-5">
            <button v-if="!noData" class="btn btn-success w-100" @click.prevent="Download()">دریافت دیسکت</button>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue'
import Tab from '@/components/Tab/Tab.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
export default {
  data() {
    return {
      SalaryId: 0,
      DataAxois: {
        BedehiMaliatiMaheGozashte: '',
        BedehiMaliatiMaheJari: '',
        MablaghPardakhti: '',
        MablaghPardakhtiKhazane: '',
        salaryId: 0,
        TarixCheck: '',
        TarixPardakhtKhazane: '',
        TarixSabetRoozaname: '',
        CodeBank: 0,
        NahvePardakhetId: 0,
        SerialCheck: '',
        ShomareHesab: '',
        TblWorkshopId: 0,
      },
      noData: false,
      Tablist: [{ header: 'اطلاعات حقوق بگیران' }, { header: 'فهرست حقوق' }, { header: 'خلاصه فهرست حقوق ' }],
      WH: '',
      WK: '',
      WP: '',
      isEdit: false,
      listpersonel: [],
      TaxDisketPersonelState: [],
      DataAxiosPost: {
        ArryfildValue: {},
        Method: 'post',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
    }
  },
  components: { Card, Tab, SearchableCombo, datePicker: VuePersianDatetimePicker },
  beforeMount() {
    this.SalaryId = this.$route.query.SalaryId
  },
  mounted() {
    this.GetData()
  },
  methods: {
    GetData() {
      var DataAxois = {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'TaxDisket/GetDisketContent/' + this.SalaryId,
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxois)
        .then((data) => {
          if (data != null) {
            if (data.IsSuccess == true) {
              this.WP = data.Data.WP
              this.WK = data.Data.WK
              this.WH = data.Data.WH
            } else {
              this.noData = true
              this.DataAxois.BedehiMaliatiMaheJari = this.DataAxois.MablaghPardakhti = this.DataAxois.MablaghPardakhtiKhazane = this.$Comma3ragham(data.Data)
              this.DataAxois.BedehiMaliatiMaheGozashte = 0
            }
          }
        })
        .finally(() => { })
    },
    GetWorkShopCombo(data) {
      if (data.id != null) {
        this.DataAxois.TblWorkshopId = data.id
        this.DataAxiosPost.ArryfildValue.workShopId = data.id
        this.GetPersonel(this.DataAxois.TblWorkshopId)
      }
    },
    GetNahvePardakhetGrp28(data) {
      if (data.id != null) {
        this.DataAxois.NahvePardakhetId = data.id
      }
    },
    GetBankGrp29(data) {
      if (data.id != null) {
        this.DataAxois.CodeBank = data.id
      }
    },
    GetPersonel(workShopId) {
      var DataAxois = {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'Workshop/GetPersonnel/' + workShopId,
        Token: this.$session.get('Token'),
      }

      this.$PostData(DataAxois).then((data) => {
        if (data.IsSuccess == true && data.Data != null) {
          var info = []
          this.listpersonel = []
          info = data.Data
          for (let index = 0; index < info.length; index++) {
            if (this.isEdit) {
              info[index]['TaxDisketPersonelState'] = this.TaxDisketPersonelState.find(x => x.PersonelId == info[index].Id).TaxDisketPersonelState
            } else {
              info[index]['TaxDisketPersonelState'] = 1
            }
            this.listpersonel.push(info[index])
          }
        } else {
          this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
        }
      })
    },

    EditDeta() {
      if (this.$ValidForm(this.$route.name)) {
        let data = {
          Id: this.DataAxois.Id,
          TblSalaryId: this.DataAxois.salaryId,
          BedehiMaliatiMaheJari: this.DataAxois.BedehiMaliatiMaheJari,
          BedehiMaliatiMaheGozashte: this.DataAxois.BedehiMaliatiMaheGozashte,
          TarixSabetRoozaname: this.DataAxois.TarixSabetRoozaname,
          NahvePardakhetGrp28: this.DataAxois.NahvePardakhetId,
          SerialCheck: this.DataAxois.SerialCheck,
          TarixCheck: this.DataAxois.TarixCheck,
          BankGrp29: this.DataAxois.CodeBank,
          NameShobe: this.DataAxois.NameShobe,
          ShomareHesab: this.DataAxois.ShomareHesab,
          MablaghPardakhti: this.DataAxois.MablaghPardakhti,
          TarixPardakhtKhazane: this.DataAxois.TarixPardakhtKhazane,
          MablaghPardakhtiKhazane: this.DataAxois.MablaghPardakhtiKhazane,
          WorkShopId: this.DataAxois.TblWorkshopId,
          TaxDisketPersonels: []
        }

        this.listpersonel.forEach(x => {
          data.TaxDisketPersonels.push({
            TblTaxDisketId: data.Id,
            PersonelId: x.Id,
            TaxDisketPersonelState: x.TaxDisketPersonelState
          })
        })

        let axios = {
          Action: 'TaxDisket',
          ArryfildValue: data,
          Method: 'put',
        }
        this.$PostData(axios).then((data) => {
          if (data.isSuccess == true) {
            this.$toasted.success('دیسکت مالیات با موفقیت ویرایش شد', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            this.noData = false
            this.GetData()
          } else {
            if (data.IsSuccess == false) {
              this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
            }
          }
        })
      }
    },


    SaveDeta() {
      if (this.$ValidForm(this.$route.name)) {
        this.DataAxiosPost.Action = 'TaxDisket'
        this.DataAxiosPost.ArryfildValue.BedehiMaliatiMaheGozashte = this.DataAxois.BedehiMaliatiMaheGozashte
        this.DataAxiosPost.ArryfildValue.BedehiMaliatiMaheJari = this.DataAxois.BedehiMaliatiMaheJari
        this.DataAxiosPost.ArryfildValue.MablaghPardakhti = this.DataAxois.MablaghPardakhti
        this.DataAxiosPost.ArryfildValue.MablaghPardakhtiKhazane = this.DataAxois.MablaghPardakhtiKhazane
        this.DataAxiosPost.ArryfildValue.tblsalaryId = this.SalaryId
        this.DataAxiosPost.ArryfildValue.TarixCheck = this.DataAxois.TarixCheck
        this.DataAxiosPost.ArryfildValue.TarixPardakhtKhazane = this.DataAxois.MablaghPardakhtiKhazane
        this.DataAxiosPost.ArryfildValue.TarixSabetRoozaname = this.DataAxois.TarixSabetRoozaname
        this.DataAxiosPost.ArryfildValue.BankGrp29 = this.DataAxois.CodeBank
        this.DataAxiosPost.ArryfildValue.NahvePardakhetGrp28 = this.DataAxois.NahvePardakhetId
        this.DataAxiosPost.ArryfildValue.SerialCheck = this.DataAxois.SerialCheck
        this.DataAxiosPost.ArryfildValue.ShomareHesab = this.DataAxois.ShomareHesab
        this.DataAxiosPost.ArryfildValue.NameShobe = this.DataAxois.NameShobe
        this.DataAxiosPost.ArryfildValue.TaxDisketPersonels = this.listpersonel

        this.$PostData(this.DataAxiosPost).then((data) => {
          if (data.isSuccess == true) {
            this.$toasted.success('دیسکت مالیات با موفقیت ایجاد شد', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            this.noData = false
            this.GetData()
          } else {
            if (data.IsSuccess == false) {
              this.$mySweetDefaultTost('خطایی رخ داده!', data.Message, 'error', 3000)
            }
          }
        })
      }
    },
    getEditDeta() {
      this.noData = true
      var DataAxois = {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'TaxDisket/GetDisketTaxForEdit/' + this.SalaryId,
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxois)
        .then((data) => {
          if (data != null) {
            if (data.IsSuccess == true) {
              this.isEdit = true
              this.DataAxois.BedehiMaliatiMaheGozashte = data.Data.BedehiMaliatiMaheGozashte
              this.DataAxois.BedehiMaliatiMaheJari = data.Data.BedehiMaliatiMaheJari
              this.DataAxois.MablaghPardakhti = data.Data.MablaghPardakhti
              this.DataAxois.MablaghPardakhtiKhazane = data.Data.MablaghPardakhtiKhazane
              this.DataAxois.salaryId = this.SalaryId
              this.DataAxois.TarixCheck = data.Data.TarixCheck
              this.DataAxois.TarixPardakhtKhazane = data.Data.MablaghPardakhtiKhazane
              this.DataAxois.TarixSabetRoozaname = data.Data.TarixSabetRoozaname
              this.DataAxois.CodeBank = data.Data.BankGrp29
              this.DataAxois.NahvePardakhetId = data.Data.NahvePardakhetGrp28
              this.DataAxois.SerialCheck = data.Data.SerialCheck
              this.DataAxois.ShomareHesab = data.Data.ShomareHesab
              this.DataAxois.NameShobe = data.Data.NameShobe
              this.TaxDisketPersonelState = data.Data.TaxDisketPersonels
              this.DataAxois.TblWorkshopId = data.Data.WorkShopId
              this.DataAxois.Id = data.Data.Id
            }
          }
        })
        .finally(() => { })
    },
    cancelEdit() {
      this.noData = false
      this.isEdit = false
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = window.atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    Download() {
      var DataAxois = {
        ArryfildValue: {},
        Method: 'Get',
        Action: 'TaxDisket/Download/' + this.SalaryId,
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxois).then((data) => {
        if (data != null) {
          if (data.IsSuccess == true) {
            var taix = this.WK.substring(0, 4) + '0' + this.WK.substring(5, 6)
            const WH = this.dataURLtoFile('data:text/plain;base64,' + data.Data.WH, 'WH' + taix + '.txt')
            const WP = this.dataURLtoFile('data:text/plain;base64,' + data.Data.WP, 'WP' + taix + '.txt')
            const WK = this.dataURLtoFile('data:text/plain;base64,' + data.Data.WK, 'WK' + taix + '.txt')
            this.GetfordownloadFile(WH)
            this.GetfordownloadFile(WP)
            this.GetfordownloadFile(WK)
          }
        }
      })
    },
    GetfordownloadFile(file) {
      const link = document.createElement('a')
      const url = URL.createObjectURL(file)

      link.href = url
      link.download = file.name
      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>

<style scoped>
.ListHover:hover {
  background: var(--table-background);
}
</style>
